import {
  Environment,
  type SessionListItem,
  SessionStatus,
  TerminationReason,
} from "src/clients/agent-management";
import { formatTerminationReason } from "src/utils/agents/formatTerminationReason";

const ENVIRONMENT_LABELS: Record<Environment, string> = {
  [Environment.SANDBOX]: "Sandbox",
  [Environment.PRODUCTION]: "Live",
};

const CUSTOM_FAILURE_COPY: Partial<
  Record<TerminationReason, (environment: Environment) => string>
> = {
  [TerminationReason.FILE_NOT_FOUND]: (environment) =>
    `The copilot could not open the files attached to this case in the ${ENVIRONMENT_LABELS[environment]} environment. Files must be uploaded to the ${ENVIRONMENT_LABELS[environment]} environment.`,
};

export const getCopilotFailureMessage = (
  session: SessionListItem | undefined,
): string | null => {
  if (session?.status !== SessionStatus.FAILED) return null;

  const reason = session.termination_reason;
  if (!reason) return "Something went wrong";

  const customCopy = CUSTOM_FAILURE_COPY[reason];
  if (customCopy) return customCopy(session.environment);

  return `Something went wrong: ${formatTerminationReason(reason)}`;
};
